import { getPermissions } from './permissions';

export const canView = (state, viewPermission) => {
	const permissions = getPermissions(state);
	const hasAccess = permissions.hasFullAccess || permissions[viewPermission];
	return hasAccess;
};
